import Vue from 'vue';

import './styles/quasar.scss';
import iconSet from 'quasar/icon-set/fontawesome-v5';
import '@quasar/extras/fontawesome-v5/fontawesome-v5.css';
import { quasarComponents as sharedQuasarComponents } from 'mycorems-app-shared';
import {
  quasarComponents as accountsQuasarComponents,
  quasarDirectives as accountsQuasarDirectives,
} from 'mycorems-app-accounts';
import { quasarComponents as billingQuasarComponents } from 'mycorems-app-billing';
import {
  Quasar,
  Meta,
  Dialog,
  Notify,
} from 'quasar';


Vue.use(Quasar, {
  config: {},
  components: {
    ...sharedQuasarComponents,
    ...accountsQuasarComponents,
    ...billingQuasarComponents,
  },
  directives: {
    ...accountsQuasarDirectives,
  },
  plugins: {
    Meta,
    Dialog,
    Notify,
  },
  iconSet,
});
